import { ChangeDetectionStrategy, Component } from "@angular/core";
import { TranslocoDirective } from "@jsverse/transloco";
import { OnboardingCtaComponent } from "@m19-board/containers/board-layout/board-sidebar/onboarding-cta.component";
import { OverlayFeatureListComponent } from "@m19-board/overlay/overlay-feature-list/overlay-feature-list.component";
import { OverlayLayoutComponent } from "@m19-board/overlay/overlay-layout/overlay-layout.component";
import { OverlayRule } from "@m19-board/overlay/overlay-service/overlay-rules";

@Component({
  selector: "app-hourly-not-in-billing-plan-overlay",
  imports: [TranslocoDirective, OverlayLayoutComponent, OverlayFeatureListComponent, OnboardingCtaComponent],
  template: `
    <app-overlay-layout
      *transloco="let t"
      variant="promo"
      [title]="t('overlays.hourly_not_in_billing_plan_title')"
      [subtitle]="t('overlays.hourly_not_in_billing_plan_subtitle')"
    >
      <app-overlay-feature-list
        overlayBody
        [featureKeys]="[
          'overlays.hourly_not_in_billing_plan_benefit_1',
          'overlays.hourly_not_in_billing_plan_benefit_2',
          'overlays.hourly_not_in_billing_plan_benefit_3',
        ]"
      />
      <app-onboarding-cta overlayCta />
    </app-overlay-layout>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HourlyNotInBillingPlanOverlayComponent {
  static readonly rule = OverlayRule.HOURLY_NOT_IN_BILLING_PLAN;
}
